import axios from "axios";
import { fetch } from "../../utils/fetch";

export const fetchDoLogin = async (payload: any) =>

  fetch(
    `${process.env.MS_LOGIN}${process.env.LOGIN_ENDPOINT}`,
    // 'https://e29e-139-0-8-92.ngrok-free.app/login-dev-only',
    axios.post,
    JSON.stringify(payload),
    {
      headers: { "Content-Type": "application-bribrain/json" },
    }
  );

export const fetchDoLoginSingleProduct = async (product_id: any, token: any) =>

  fetch(
    `${process.env.MS_LOGIN}/auth/product/${product_id}`,
    // `https://e29e-139-0-8-92.ngrok-free.app/auth/product/${product_id}`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json"
        , Authorization: `${token}`,
      },
    }
  );

export const fetchListProduk = async (token: any) =>

  fetch(
    `${process.env.MS_LOGIN}/auth/list-product`,
    // 'https://e29e-139-0-8-92.ngrok-free.app/auth/list-product',
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        Authorization: `${token}`,
      },

    }
  );


export const fetchDoLogout = async (token: any) =>
  fetch(
    `${process.env.MS_LOGIN}/auth/logout`,
    axios.post,
    // JSON.stringify(payload),
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
      },
    }
  );

export const fetchGetCaptcha = async (payload: any) =>
  fetch(
    `${process.env.MS_LOGIN}/getCaptcha`,

    axios.post,
    JSON.stringify(payload),
    {
      headers: { "Content-Type": "application-bribrain/json" },
    }
  );

export const fetchTermsAndConditions = async (token: string) =>
  fetch(
    `${process.env.MS_BRIBRAIN_DASHBOARD}/dashboard/terms-and-conditions`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        Authorization: `${token}`,
      },
    }
  );

export const fetchValidateTokenBSS = async (payload: any) =>
  fetch(
    `${process.env.MS_LOGIN}/login-bss`,
    axios.post,
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application-bribrain/json",
      },
    }
  );

export const fetchValidateTokenBristars = async (payload: any) =>
  fetch(
    `${process.env.MS_LOGIN}/login-bristars`,
    axios.post,
    JSON.stringify(payload),
    {
      headers: {
        "Content-Type": "application-bribrain/json",
      },
    }
  );

export type RequestDataChangePasswordSvc = {
  payload: {
    key: string;
    password: string;
    confirm_password: string;
  };
};
export const postChangePasswordSvc = (data: RequestDataChangePasswordSvc) => {
  return fetch(
    `${process?.env?.MS_LOGIN}/change-password`,
    axios.post,
    data?.payload,
    {
      headers: {
        "Content-Type": "application-bribrain/json",
      },
    }
  );
};

export const fetchListWordStyling = async () =>
  fetch(
    `${process.env.MS_BRIBRAIN_MAIN}/list-word-styling`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        "x-api-key": `${process.env.X_API_KEY}`,
      },
    }
  );

export const fetchHeadline = async () =>
  fetch(
    `${process.env.MS_BRIBRAIN_MAIN}/headline`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        "x-api-key": `${process.env.X_API_KEY}`,
      },
    }
  );

export const fetchListServices = async () =>
  fetch(
    `${process.env.MS_BRIBRAIN_MAIN}/list-layanan-utama`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        "x-api-key": `${process.env.X_API_KEY}`,
      },
    }
  );


export const fetchAnnouncement = async () =>
  fetch(
    `${process.env.MS_BRIBRAIN_MAIN}/announcement`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        "x-api-key": `${process.env.X_API_KEY}`,
      },
    }
  );

export const fetchListDaftarProduk = async () =>
  fetch(
    `${process.env.MS_BRIBRAIN_MAIN}/list-daftar-produk`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        "x-api-key": `${process.env.X_API_KEY}`,
      },
    }
  );

export const fetchCallToAction = async () =>
  fetch(
    `${process.env.MS_BRIBRAIN_MAIN}/call-to-action`,
    axios.post,
    {},
    {
      headers: {
        "Content-Type": "application-bribrain/json",
        "x-api-key": `${process.env.X_API_KEY}`,
      },
    }
  );

export default {
  fetchDoLogin,
  postChangePasswordSvc,
  fetchDoLogout,
  fetchGetCaptcha,
  fetchTermsAndConditions,
  fetchValidateTokenBSS,
};
